import Search from './search';

const searchConfig = {
  name: 'Search',
  class: Search,
  querySelector: {
    controller: '.search-form__trigger',
    focusElement: '.search-form__field',
    closeButton: '.search-form__close',
    target: '.search-form__container',
  },
};

export default searchConfig;
